var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuelType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pf0ta",
    d: "M363.74 946.05v7.1c0 .31-.2.52-.5.52h-10.16c-.3 0-.51-.2-.51-.51v-7.11c0-.3.2-.51.5-.51h10.17c.3 0 .5.2.5.5zm-1.01.5h-9.14v6.1h9.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf0tb",
    d: "M363.74 957.22v10.16c0 .3-.2.5-.5.5h-10.16c-.3 0-.51-.2-.51-.5v-10.16c0-.3.2-.51.5-.51h10.17c.3 0 .5.2.5.5zm-1.01.5h-9.14v9.15h9.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf0tc",
    d: "M378.99 954.68c0 .3-.2.51-.51.51h-.5v11.68a5.11 5.11 0 0 1-5.09 5.08h-.35a5.2 5.2 0 0 1-4.73-5.23v-9.5c0-.94-.65-1.74-1.52-1.96v15.17h.5c.31 0 .52.2.52.5v2.04c0 .3-.2.5-.51.5h-17.27c-.3 0-.51-.2-.51-.5v-2.03c0-.3.2-.51.5-.51h.52V943.5c0-.3.2-.51.5-.51h15.24c.3 0 .51.2.51.5v8.67a5.1 5.1 0 0 1 4.57 5.05v9.65c0 .56.26 1.12.66 1.53.4.4.97.56 1.58.5a2.1 2.1 0 0 0 1.82-2.13v-12.09c0-1.32-1.87-4.11-3.3-4.52-.45-.15-.76-.5-.76-1.01 0-.3.15-.61.36-.82.2-.2.5-.3.81-.25 3.05.5 6.96 3.76 6.96 6.6zm-12.7 17.78v-1.02h-16.25v1.02zm-1.02-2.03v-26.41h-14.22v26.4zm12.2-16.26h.45c-.46-2.18-3.66-4.67-6.04-5.02 1.88.55 4.06 3.8 4.06 5.53v12.1c0 1.62-1.22 2.99-2.74 3.14-.87.1-1.73-.2-2.34-.76a2.98 2.98 0 0 1-1.01-2.24v-9.7a4.06 4.06 0 0 0-3.56-4.01v1.02a3.06 3.06 0 0 1 2.54 3v9.5a4.17 4.17 0 0 0 3.8 4.2 4.03 4.03 0 0 0 4.32-4.01v-12.24c0-.3.21-.5.51-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf0td",
    d: "M355.62 960.27h5.08c.3 0 .5-.2.5-.51 0-.3-.2-.51-.5-.51h-5.08c-.3 0-.51.2-.51.5 0 .31.2.52.5.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf0te",
    d: "M355.62 962.8h5.08c.3 0 .5-.2.5-.5s-.2-.51-.5-.51h-5.08c-.3 0-.51.2-.51.5 0 .31.2.52.5.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pf0tf",
    d: "M355.62 965.35h5.08c.3 0 .5-.2.5-.51 0-.3-.2-.51-.5-.51h-5.08c-.3 0-.51.2-.51.5 0 .31.2.52.5.52z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-349 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#pf0ta"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-349 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#pf0tb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-349 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#pf0tc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-349 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#pf0td"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-349 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#pf0te"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-349 -943)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#de1f26",
    xlinkHref: "#pf0tf"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelType);
export default __webpack_public_path__ + "static/media/fuel-type.046bf764ca39ed9fea7b43dfec6646b8.svg";
export { ForwardRef as ReactComponent };